/******************************************
 *  Author : Suraj Sharma
 *  Created On : Fri Mar 12 2021
 *  File : index.jsx
 *******************************************/
import ClusterMap from './ClusterMap';

export default ClusterMap;